import React, {  Component } from 'react';
import { connect } from 'react-redux';

class Confirmation extends Component {

    render() {
        return (
			<div>
				<h1>Thank You for Registering on GE Appliances CustomerNet!</h1>
				<p>
					Your request has been submitted and is pending approval of the account administrator and/or your GE Area Sales Manager.<br/>
					You will be notified via email once approved.
				</p>
			</div>
        );
    }

}

const mapStateToProps = (state) => {
  return {state};
};

Confirmation = connect(mapStateToProps)(Confirmation);
export default Confirmation;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/RequestAccess/confirmation.js